<template lang="pug">
.container.grid-lg.my-2.py-2
  fieldset(:disabled="loading")
    form(@submit.prevent="save")
      .panel
        .panel-header
          .h5 Nova OS Avulsa
        .panel-body.columns
          form-group.column.col-12(
            :label="'ordem_servico.assunto' | tModel",
            :validation="$v.form.assunto_id"
          )
            assunto-picker(
              v-model="$v.form.assunto_id.$model",
              @selected="onSelectedAssunto"
            )
          form-group.column.col-12(
            :label="'ordem_servico.situacao' | tModel",
            :validation="$v.form.situacao"
          )
            select-ordem-servico-situacao(
              v-model="$v.form.situacao.$model",
              :situacoes="allowedSituacoes"
            )
          form-group.column.col-12(
            :label="'ordem_servico.usuario_responsavel' | tModel",
            :validation="$v.form.usuario_responsavel_id"
          )
            fiscal-picker(v-model="$v.form.usuario_responsavel_id.$model")
          form-group.column.col-12(
            :label="'ordem_servico.analista' | tModel",
            :validation="$v.form.analista_id",
            v-if="assunto && assunto.permite_analise"
          )
            fiscal-picker(v-model="$v.form.analista_id.$model")
          address-picker(@selected="onEnderecoSelected" ref="addressPicker" noAddressText="Informe um endereço para a OS-m")
          .column.col-12.divider.text-center(data-content="Protocolo")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_tipo' | tModel",
            :validation="$v.form.protocolo_tipo"
          )
            select-protocolo-tipo(v-model="$v.form.protocolo_tipo.$model")
          form-group.column.col-3.col-sm-12(
            v-if="form.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.protocolo_numero"
          )
            the-mask.form-input(
              v-model="$v.form.protocolo_numero.$model",
              type="tel",
              mask="##.##.########/####.##",
              :masked="true"
            )
          form-group.column.col-3.col-sm-12(
            v-else,
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.protocolo_numero"
          )
            input.form-input(v-model="$v.form.protocolo_numero.$model")
          form-group.column.col-3.col-sm-12(
            :disabled="form.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_ano' | tModel",
            :validation="$v.form.protocolo_ano"
          )
            year.form-input(v-model="$v.form.protocolo_ano.$model")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_data' | tModel",
            :validation="$v.form.protocolo_data"
          )
            datepicker(v-model="$v.form.protocolo_data.$model")
          .column.col-12.divider.text-center
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.prazo' | tModel",
            :validation="$v.form.prazo"
          )
            int.form-input(v-model="$v.form.prazo.$model")
          form-group.column.col-12(:validation="$v.form.agendar")
            label.form-switch
              input(type="checkbox", v-model="$v.form.agendar.$model")
              i.form-icon
              | É necessário agendar
          form-group.column.col-12(
            :label="'ordem_servico_info.obs' | tModel",
            :validation="$v.form.info.obs"
          )
            textarea.form-input(v-model="$v.form.info.obs.$model", rows="4")
        .panel-footer.text-right
          button.btn.btn-primary(:disabled="$v.$invalid", :class="loading") Salvar
</template>

<script>
import { deepKey } from "paliari-js-utils"
import { required, maxLength } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"
import AddressPicker from "@/views/osm/servicos/create/components/AddressPicker.vue"

export default {
  components: { AddressPicker },
  vuex: {
    servicos: {
      getters: ["loading"],
      actions: ["fetchCreate"],
    },
  },
  computed: {
    protocoloTipos() {
      return this.$i18n.t("enums.db.enum_protocolo_tipo")
    },
  },
  methods: {
    onEnderecoSelected(endereco) {
      this.form.endereco = endereco
    },
    async save() {
      try {
        const { id } = await this.fetchCreate(this.form)
        this.$toaster.success("OS gerada com sucesso")
        this.$router.replace({ name: "app.osm.servicos.show", params: { id } })
      } catch (e) {
        toastErrors(e)
      }
    },
    onSelectedAssunto(assunto) {
      this.$set(this, "assunto", assunto)
      this.$set(this.form, "prazo", deepKey(assunto, "prazo") || 0)
    },
  },
  data() {
    return {
      form: {
        assunto_id: null,
        situacao: null,
        usuario_responsavel_id: null,
        analista_id: null,
        protocolo_tipo: "geral",
        protocolo_numero: null,
        protocolo_ano: 0,
        endereco: null,
        protocolo_data: "",
        agendar: false,
        info: { obs: "" },
        prazo: 0,
      },
      allowedSituacoes: {
        abertura: "Em Abertura",
        andamento: "Em andamento",
        em_distribuicao: "Em distribuição",
        aguardando_distribuir: "Aguardando Distribuir",
      },
      assunto: null,
    }
  },
  validations() {
    const validations = {
      form: {
        assunto_id: { required },
        situacao: {},
        usuario_responsavel_id: {},
        analista_id: {},
        endereco: {},
        agendar: {},
        protocolo_tipo: {},
        protocolo_numero: {},
        protocolo_ano: {},
        protocolo_data: {},
        info: { obs: { required, maxLength: maxLength(4000) } },
        prazo: {},
      },
    }
    if (this.form.situacao === "em_distribuicao") {
      validations.form.usuario_responsavel_id = { required }
    }
    if (this.assunto && this.assunto.exige_analise) {
      validations.form.analista_id = { required }
    }
    return validations
  },
}
</script>
